import { render, staticRenderFns } from "./AddEditMovie.vue?vue&type=template&id=4300b898&scoped=true"
import script from "./AddEditMovie.vue?vue&type=script&lang=js"
export * from "./AddEditMovie.vue?vue&type=script&lang=js"
import style0 from "./AddEditMovie.vue?vue&type=style&index=0&id=4300b898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4300b898",
  null
  
)

export default component.exports